import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OAuthService);
  const router = inject(Router)
  const skipUrls = [
    "https://accounts.google.com/.well-known/openid-configuration",
    "https://www.googleapis.com/oauth2/v3/certs",
    "https://oauth2.googleapis.com/token"
  ];

  const shouldSkip = skipUrls.some(url => req.url.includes(url));

  if (shouldSkip) {
    return next(req);
  }

  if (oauthService.hasValidAccessToken() === false && oauthService.hasValidIdToken() === false) {
    router.navigate(['/'])
    return throwError(() => new Error('Invalid or expired token'));
  }

  return next(req);
};
